module.exports = __webpack_public_path__ + "img/maciej-pro.4ad3bc72.jpg";